// Hari K : 22-12-2023 : BT-119138 - Breeze - funds-Mandate Register-start
import { forwardRef, memo, useEffect, useState } from "react"
import { handleModal } from "../../redux/actions/modals";
import { useDispatch, useSelector } from "react-redux";
import { BzButton, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
const MandateRegisterModal = () => {

    const dispatch = useDispatch()
    const modals = useSelector(state => state.modals.modals);
    const bankAccList = useSelector(state => state.funds.bankAccList);
    const [isSatisfiedAllparameters, setIsSatisfiedAllparameters] = useState(true)
    const [mandateInputs, setMandateInputs] = useState({ SIP: 'NSIP', selectedBank: {}, amount: 0, endDate: '', IFSC: '', MICRCode: '' })

    const onHide = () => {
        dispatch(handleModal([{ "MANDATE_REGISTER_MODAL": false }]));
    };

    useEffect(() => {
        if (bankAccList && bankAccList?.length) {
        setMandateInputs({ ...mandateInputs, selectedBank: bankAccList[0] })
        }else{}
    }, [bankAccList])

    const handleBankChange = (bankDetails) => {
        setMandateInputs({ ...mandateInputs, selectedBank: bankDetails })
    };

    const handleOrderInputs = (value, key) => {
        if (key === "amount") {
            setMandateInputs({ ...mandateInputs, amount: value })
        } else if (key === "IFSC") {
            setMandateInputs({ ...mandateInputs, IFSC: value })
        } else if (key === "MICRCode") {
            setMandateInputs({ ...mandateInputs, MICRCode: value })
        } else if (key === "endDate") {
            setMandateInputs({ ...mandateInputs, endDate: value })
        }
    }


    const handleSIPChange = (value) => {
        setMandateInputs({ ...mandateInputs, SIP: value })
    }

    const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
        <div
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </div>
    ));

    return (

        <BzModal show={modals['MANDATE_REGISTER_MODAL']} onHide={onHide}>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={10} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>Mandate Registration</div>
                        </Col>
                        <Col md={2} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 my-3 px-2'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <div className='d-flex justify-content-start align-items-center add-funds-dropdown-wrapper'>
                                <Dropdown>
                                    <Dropdown.Toggle as={CustomDropdownToggle}>
                                        <div className='d-flex justify-content-start align-items-center'>
                                            {mandateInputs?.selectedBank && Object.keys(mandateInputs?.selectedBank)?.length > 0 ?
                                                <div className='font-medium font-size3 color-text'>{mandateInputs?.selectedBank?.sBankId}</div>
                                                : null}
                                            <div className='icon-20 icon-sort-down icon-dark ms-2'></div>
                                        </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {bankAccList?.length && bankAccList?.map((eachBank) => (
                                            <Dropdown.Item key={eachBank?.sAccountNo} onClick={() => { handleBankChange(eachBank); }} value={eachBank.sAccountNo}>{eachBank?.sBankId}</Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-3'>
                        <Col>
                            <div className='font-regular font-size3 color-text px-2'>Account No.XXX{mandateInputs?.selectedBank?.sAccountNo?.slice(-4)}</div>
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        <Col md={5}>                            
                                <div className='font-regular font-size3 color-text'>Amount</div>
                                <div className='input-group align-items-center add-funds-input'>
                                    <BzInputText type="number" autoComplete='off' name="amount" className='text-start font-size9 p-0 form-control font-medium bdr-none' onChange={(e) => handleOrderInputs(e.target.value, "amount")} />
                                </div>                            
                        </Col>
                        <Col>&nbsp;</Col>
                        <Col md={5}>
                            <div>
                                <div className='font-regular font-size3 color-text'>IFSC</div>
                                <div className='input-group align-items-center add-funds-input'>
                                    <BzInputText type="number" autoComplete='off' name="IFSC" className='text-start font-size9 p-0 form-control font-medium bdr-none' onChange={(e) => handleOrderInputs(e.target.value, "IFSC")} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 mt-4'>
                        <Col md={5}>                            
                                <div className='font-regular font-size3 color-text'>MICR Code</div>
                                <div className='input-group align-items-center add-funds-input'>
                                    <BzInputText type="number" autoComplete='off' name="MICRCode" className='text-start font-size9 p-0 form-control font-medium bdr-none' onChange={(e) => handleOrderInputs(e.target.value, "MICRCode")} />
                                </div>                            
                        </Col>
                            <Col>&nbsp;</Col>
                        <Col md={5}>
                            <div>
                                <div className='font-regular font-size3 color-text'>Ends Date</div>
                                <div className='input-group align-items-center add-funds-input'>
                                    <BzInputText type="date" autoComplete='off' name="endDate" className='font-size9 font-medium color-subtext form-control p-0 bdr-none' onChange={(e) => handleOrderInputs(e.target.value, "endDate")} />
                                </div>
                            </div>                            
                        </Col>
                    </Row>
                    <Row className='g-0 mt-2'>
                        <Col md={5}>&nbsp;</Col>
                        <Col>&nbsp;</Col>
                        <Col md={5}>
                            <div className='d-flex justify-content-start align-items-center'>
                                <input type='Checkbox' className='form-check-input me-1' value=""/>
                                <div className='font-medium font-size3 color-text p-t-3'>Until Cancel</div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        <Col className='d-flex'>
                            <div className={mandateInputs?.SIP === 'NSIP' ? 'addfunds-modal-radio-card active' : 'addfunds-modal-radio-card'} onClick={() => handleSIPChange("NSIP")}>
                                <input type='radio' className='form-check-input mb-3' value="NSIP" checked={mandateInputs?.SIP === 'NSIP'} />
                                <div className='font-medium font-size4 color-text'>NSIP</div>
                            </div>
                            <div className={mandateInputs?.SIP === 'ESIP' ? 'addfunds-modal-radio-card active' : 'addfunds-modal-radio-card'} onClick={() => handleSIPChange("ESIP")}>
                                <input type='radio' className='form-check-input mb-3' value="ESIP" checked={mandateInputs?.SIP === 'ESIP'} />
                                <div className='font-medium font-size4 color-text'>NSIP</div>
                            </div>
                            <div className={mandateInputs?.SIP === 'XSIP' ? 'addfunds-modal-radio-card active' : 'addfunds-modal-radio-card'} onClick={() => handleSIPChange("XSIP")}>
                                <input type='radio' className='form-check-input mb-3' value="XSIP" checked={mandateInputs?.SIP === 'XSIP'} />
                                <div className='font-medium font-size4 color-text'>NSIP</div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter className='bdr-none'>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0'>
                        <Col>
                            <BzButton className='btn btn-md btn-primary btn-block' disabled={isSatisfiedAllparameters} >Set Up Auto Debit</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    )
}

export default memo(MandateRegisterModal)
// Hari K : 22-12-2023 : BT-119138 - Breeze - funds-Mandate Register-end